import {
  GET_REFUND_COUPONS,
  SELECT_REFUND_COUPON,
  CANCEL_REFUND_COUPON,
  INIT_REFUND_COUPON,
} from './actions';

const initialState = {
  refundWay: 2, // 1 原流水退款 2 极速退款 3 南航账户
  couponsData: [],
  selectCouponCodes: [], // 已选的变更优惠券code
  couponsPsgSegment: {}, // 已选的变更优惠券对应使用的乘机人和航段
  couponsMap: {}, // 已选的变更优惠券数据
  psgsCharge: {},
};

export default function CouponsReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_REFUND_COUPON:
      return initialState;
    case `${GET_REFUND_COUPONS}_SUCCESS`:
      const {
        meta: {
          previousAction: { psgsCharge, refundWay },
        },
        payload: {
          data: {
            result: { coupon },
          },
        },
      } = action;
      if (coupon && coupon.length !== 0) {
        let prevUrl = window.sessionStorage.getItem('historyUrl');
        if (prevUrl.includes('EndorsedApply') && state.selectCouponCodes.length > 0) {
          return Object.assign({}, state, {
            couponsData: coupon,
            psgsCharge: psgsCharge,
            refundWay: refundWay,
            selectCouponCodes: [], 
            couponsPsgSegment: {}, 
            couponsMap: {}, 
          });
        } else {
          return Object.assign({}, state, {
            couponsData: coupon,
            psgsCharge: psgsCharge,
            refundWay: refundWay,
          });
        }
      } else {
        return Object.assign({}, state, {
          selectCouponCodes: [], 
          couponsPsgSegment: {}, 
          couponsMap: {}, 
        });
      }
    case SELECT_REFUND_COUPON:
      delete action.couponData.originData;
      return Object.assign({}, state, {
        selectCouponCodes: [...state.selectCouponCodes, action.code],
        couponsMap: Object.assign({}, state.couponsMap, {
          [action.code]: Object.assign(
            {},
            state.couponsData.filter(
              item => item.discountcode === action.code
            )[0],
            {
              couponData: action.couponData,
            }
          ),
        }),
        couponsPsgSegment: Object.assign({}, state.couponsPsgSegment, {
          [action.code]: action.psgSegmentData,
        }),
      });
    case CANCEL_REFUND_COUPON:
      let obj = { ...state.couponsMap },
        arr = [...state.selectCouponCodes],
        psg = { ...state.couponsPsgSegment };
      delete obj[action.couponCode];
      delete psg[action.couponCode];
      arr.splice(arr.indexOf(action.couponCode), 1);
      return Object.assign({}, state, {
        selectCouponCodes: arr,
        couponsMap: obj,
        couponsPsgSegment: psg,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/refundCoupon/modules/coupon.js